import {Login} from "./Login";
import {SignUp} from "./SignUp";
import React from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import {RecoveryPassword} from "./RecoveryPassword";

const Stack = createNativeStackNavigator();

export const LoginNavigator = ({saveAccountData}) => {
    return (
        <Stack.Navigator
            initialRouteName="Login"
            screenOptions={{
                headerShown: false
            }}>
            <Stack.Group>
                <Stack.Screen name="Login" >
                    {(props) => <Login {...props} saveAccountData={saveAccountData} />}
                </Stack.Screen>
                <Stack.Screen name="SignUp" component={SignUp} />
            </Stack.Group>
            <Stack.Group screenOptions={{ presentation: 'modal' }}>
                <Stack.Screen name="RecoveryPassword" component={RecoveryPassword} />
            </Stack.Group>
        </Stack.Navigator>
    )
}
